import { useEffect } from "react";
import { OverTimeGraph, OverTimeComments, OverTimeTable } from "./components";
import useOvertimeTable from "./hooks/OvertimeTable";
import TabMenu from "../../../components/TabMenu";
import useYear from "../../../hooks/Year";


const OverTime = () => {
    const { listOfYears, updateYear, year } = useYear(5);
    const { isLoading, projects, quantities, updateProjects } = useOvertimeTable();

    const iteamsTabs = [
        {
            label: `Resumen de vista general`,
            closable: false,
            key: "1",
            children: <OverTimeGraph listOfYears={listOfYears} quantities={quantities} updateYear={updateYear} year={year} projects={projects} />,
            rgbColors: [255, 64, 129],
        },
        {
            label: `Tabla de vista general`,
            closable: false,
            key: "2",
            children: <OverTimeTable isLoading={isLoading} listOfYears={listOfYears} projects={projects} updateYear={updateYear} year={year} />,
            rgbColors: [124, 77, 255],
        },
        {
            label: `Comentarios de proyectos`,
            closable: false,
            key: "3",
            children: (
                <OverTimeComments
                    year={year}
                    projects={projects}
                    isLoading={isLoading}
                    updateYear={updateYear}
                    listOfYears={listOfYears}
                    quantities={quantities}
                />
            ),
            rgbColors: [200, 205, 111],
        },
    ];

    useEffect(() => {
        updateProjects(year);
    }, [updateProjects, year]);


    return (
        <section
            style={{ height: "calc(100vh - 64px)" }}
            className="w-full flex flex-col justify-center items-center overflow-hidden p-4  overtime  bg-[#F5F5F5]"
        >
            <TabMenu items={iteamsTabs} />
        </section>
    );
};

export default OverTime;
